var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.getLabel(_vm.type),"color":_vm.getColor(_vm.type),"iconRight":_vm.getIcon(_vm.type),"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }